<template>
  <div>
    <!-- 新增Bank transfer Modal按鈕 -->
    <button class="btn btn-green" @click="showModal">+ New bank transfer</button>

    <!-- Modal -->
    <div
      class="transfer_modal modal fade"
      ref="cashPaymentModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-size" role="document">
        <div class="modal-content fixed-modal">
          <div class="modal-body">
            <div class="transfer_modal_header d-flex justify-content-between">
              <h5 class="modal-title" id="exampleModalLabel">New bank transfer</h5>
              <button type="button" class="close btn" @click="hideModal" aria-label="Close">X</button>
            </div>
            <div class="row d-flex align-items-stretch">
              <!-- 篩選Driver ID -->
              <div class="col-md-3 col-12">
                <div class="card h-100">
                  <div class="card-body d-flex flex-column">
                    <h5>Select drivers</h5>
                    <div class="form-group">
                      <!-- 全選司機的 checkbox -->
                      <div class="checkbox checkbox-success">
                        <input id="checkbox-primary" type="checkbox" v-model="isSelectAllDrivers" @click="toggleSelectAllDrivers">
                        <label for="checkbox-primary">Select All Drivers</label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="driver-id">Driver ID</label>
                    </div>
                    <!-- Driver ID 輸入框 -->
                    <input type="text" v-model="searchDriverId" @input="filterDrivers" class="form-control w-100" />
                    
                    <!-- 顯示篩選後的 Driver ID 列表 -->
                    <div class="search-list">
                      <span>Individual drivers:</span>
                      <div v-for="(driver, index) in filteredDriverIds" :key="index" class="form-check checkbox checkbox-success custom-driver-check">
                        <input
                          type="checkbox"
                          v-model="bankStore.selectedDriverIds"
                          :value="driver.driver_id"
                          class="form-check-input"
                          :id="driver.id"
                          @change="handleDriverSelectChange"
                        />
                        <label class="form-check-label" :for="driver.id">{{ driver.driver_id }}</label>
                      </div>
                    </div>
                    <button class="btn btn-query" @click="searchDrivers">Search</button>
                  </div>
                </div>
              </div>

              <div class="col-md-9 col-12">
                <!-- 計算Transactions Info -->
                <div class="transfer_card_container card">
                  <div class="card-body">
                    <h5>Payment info</h5>
                    <div class="table-responsive">
                      <table class="table table-bordered table-hover">
                        <thead class="thead-light">
                          <tr>
                            <th>Transactions</th>
                            <th>$SFV</th>
                            <th>Commission amount</th>
                            <th>Fees & Refunds</th>
                            <th>Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{{ selectedSummary.transactionCount }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalSFV) }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalCommissionAmount) }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalFeesAndRefunds) }}</td>
                            <td>{{ formatCurrency(selectedSummary.totalAmount) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <!-- 根據Driver ID查詢ID底下的所有交易 -->
                <div class="card mb-0">
                  <div class="card-body">
                    <div class="transfer_card_title card-title row">
                      <div class="transfer_card_title_left col-12 col-md-8 row">
                        <div class="col-xxl-5 col-md-6 d-flex align-items-center justify-content-between">
                          <label for="from-date me-2">From</label>
                          <Datepicker1
                            v-model="fromDate"
                            class="datepicker-here form-control"
                            :format="format"
                            data-language="en"
                            :enable-time-picker="false"
                            placeholder="Select..."
                          />
                        </div>
                        <div class="col-xxl-5 col-md-6 d-flex align-items-center justify-content-between">
                          <label for="to-date me-2">To</label>
                          <Datepicker1
                            v-model="toDate"
                            class="datepicker-here form-control"
                            :format="format"
                            data-language="en"
                            :enable-time-picker="false"
                            placeholder="Select..."
                          />
                        </div>
                        <div class="col-xxl-2 col-md-6 d-flex align-items-center justify-content-between">
                          <select v-model="bankStore.itemsPerPageTransactions" @change="handlePageSizeChange" class="form-select ms-2" style="width: auto;">
                            <option v-for="option in bankStore.pageSizeOptions" :key="option" :value="option">
                              {{ option }} per page
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-1"></div>
                      <div class="col-12 col-md-3 text-end d-flex justify-content-end bg-lightgreen">
                        <div class="d-inline-block d-flex justify-content-between align-items-center">
                          <span class="w-100 me-3">No. reversals</span>
                          <input type="text" class="form-control" value="12345" readonly />
                        </div>
                      </div>
                    </div>
                    <div class="table-responsive mt-3">
                      <table class="table table-hover">
                        <thead class="thead-light">
                          <tr>
                            <th>Select</th>
                            <th>Tx Date/Time</th>
                            <th>Type</th>
                            <th>Driver name</th>
                            <th>Driver ID</th>
                            <th>Face value</th>
                            <th>Comm'n %</th>
                            <th>Comm'n amount</th>
                            <th>Bank ref</th>
                            <th>Terminal</th>
                            <th>Card type</th>
                            <th>Card last 4 digits</th>
                          </tr>
                        </thead>
                        <tbody v-if="bankStore.driverTransactions.length === 0">
                          <tr>
                            <td colspan="12">
                              <div class="no-results">No results found.</div>
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr v-for="(item, index) in paginatedTransactions" :key="index">
                            <td>
                              <div class="checkbox-success">
                                <input
                                  type="checkbox"
                                  v-model="bankStore.selectedTransactionIds"
                                  :value="item.id"
                                  class="form-check-input"
                                  @change="handleTransactionSelectChange"
                                />
                              </div>
                            </td>
                            <td>{{ item.transaction_datetime }}</td>
                            <td>{{ item.type }}</td>
                            <td>{{ item.driver_name }}</td>
                            <td>{{ item.driver.driver_id }}</td>
                            <td>{{ formatCurrency(item.face_value) }}</td>
                            <td>{{ item.commn_percent }}%</td>
                            <td>{{ formatCurrency(item.comm_amount) }}</td>
                            <td>{{ item.rrn }}</td>
                            <td>{{ item.tid }}</td>
                            <td>{{ item.card_type }}</td>
                            <td>{{ item.card_last_4_digits }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <!-- 分頁和全選功能 -->
                    <div class="pagination-wrapper" v-if="bankStore.driverTransactions.length">
                      <div class="pagination-container">
                        <button @click="changeTransactionPage(1)" :disabled="bankStore.currentPageTransactions === 1"><img  src="@/assets/images/admin/arrow/prev-end.png" alt="Prev-end" style="width: 25px; height: 25px;" /></button>
                        <button @click="changeTransactionPage(bankStore.currentPageTransactions - 1)" :disabled="bankStore.currentPageTransactions === 1"><img  src="@/assets/images/admin/arrow/prev.png" alt="Prev" style="width: 25px; height: 25px;" /></button>
                        <span>Page <input type="number" v-model.number="bankStore.currentPageTransactions" @change="changeTransactionPage(bankStore.currentPageTransactions)" /> of {{ bankStore.totalTransactionPages }}</span>
                        <button @click="changeTransactionPage(bankStore.currentPageTransactions + 1)" :disabled="bankStore.currentPageTransactions === bankStore.totalTransactionPages"><img  src="@/assets/images/admin/arrow/next.png" alt="Next" style="width: 25px; height: 25px;" /></button>
                        <button @click="changeTransactionPage(bankStore.totalTransactionPages)" :disabled="bankStore.currentPageTransactions === bankStore.totalTransactionPages"><img  src="@/assets/images/admin/arrow/next-end.png" alt="Next-end" style="width: 25px; height: 25px;" /></button>
                   
                        <!-- Select All -->
                        <button class="btn btn-selectall" @click="toggleSelectAllTransactions">{{ isSelectAllTransactions ? 'Deselect All' : 'Select All' }}</button>
                      </div>
                      <div class="total-count">
                        Displaying transactions {{ (bankStore.currentPageTransactions - 1) * bankStore.itemsPerPageTransactions + 1 }} – {{ Math.min(bankStore.currentPageTransactions * bankStore.itemsPerPageTransactions, bankStore.totalTransactionEntries) }} of {{ bankStore.totalTransactionEntries }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="transfer_footer modal-footer"> 
              <button class="btn btn-green" :disabled="selectedSummary.totalAmount <= 0" @click="handleSaveClose">Save + close</button>
              <button class="btn btn-w" @click="hideModal">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from 'vue';
import { useBankStore } from '@/store/admin/cashPayment/bank';
import { usePaymentListStore } from '@/store/admin/cashPayment/paymentList';
import Datepicker1 from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import { Modal } from 'bootstrap';
import Swal from 'sweetalert2';
import dayjs from 'dayjs';

// 使用 Pinia store
const bankStore = useBankStore();
const cashPaymentStore = usePaymentListStore();
const searchDriverId = ref('');
const filteredDriverIds = ref([]); // 存儲篩選後的Driver ID
const isSelectAllDrivers = ref(false); // 全選司機的狀態
const isSelectAllTransactions = ref(false); // 全選交易的狀態

// 設定初始日期範圍：今天往前推一個月
const today = dayjs().format('YYYY-MM-DD');
const oneMonthAgo = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
const fromDate = ref(oneMonthAgo);
const toDate = ref(today);

const cashPaymentModal = ref(null);
let modalInstance = null;

const format = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
}

const formatCurrency = (value) => {
    const absValue = Math.abs(value).toFixed(2); // 取得絕對值並固定為兩位小數
    return value < 0 ? `-$${absValue}` : `$${absValue}`;
};

// 初始化選擇的交易總結
const selectedSummary = ref({
  transactionCount: 0,
  totalSFV: 0,
  totalCommissionAmount: 0,
  totalFeesAndRefunds: 0,
  totalAmount: 0,
});

// 顯示Modal
const showModal = () => {
  bankStore.fetchDriverIds(); // 獲取司機 ID
  if (!modalInstance) {
    modalInstance = new Modal(cashPaymentModal.value);
  }
  modalInstance.show();
};


// 隱藏Modal並重置所有狀態
const hideModal = () => {
  searchDriverId.value = ''; // 重置司機ID搜索框
  filteredDriverIds.value = [...bankStore.driverIds]; // 重置篩選後的司機ID
  isSelectAllDrivers.value = false; // 重置司機全選
  isSelectAllTransactions.value = false; // 重置交易全選
  bankStore.selectedDriverIds = []; // 清空已選中的司機ID
  bankStore.selectedTransactionIds = []; // 清空已選中的交易ID
  bankStore.driverTransactions = []; // 清空篩選出的交易列表

  // 重置交易統計數據
  selectedSummary.value = {
    transactionCount: 0,
    totalSFV: 0,
    totalCommissionAmount: 0,
    totalFeesAndRefunds: 0,
    totalAmount: 0,
  };

  // 重置分頁
  bankStore.currentPageTransactions = 1;

  // 重置日期為初始值
  fromDate.value = dayjs().subtract(1, 'month').format('YYYY-MM-DD');
  toDate.value = dayjs().format('YYYY-MM-DD');

  modalInstance.hide(); // 隱藏模態框
};


// 動態篩選司機ID
const filterDrivers = () => {
  const searchQuery = searchDriverId.value.toLowerCase(); // 將輸入的搜尋字串轉為小寫
  if (searchQuery === '') {
    filteredDriverIds.value = [...bankStore.driverIds]; // 如果搜索框為空，顯示所有ID
  } else {
    filteredDriverIds.value = bankStore.driverIds.filter(driver =>
      driver.driver_id.toLowerCase().startsWith(searchQuery) // 轉換 driver_id 為小寫，並檢查是否以搜尋字串開頭
    );
  }
};

// 分頁計算
const paginatedTransactions = computed(() => {
  const startIndex = (bankStore.currentPageTransactions - 1) * bankStore.itemsPerPageTransactions;
  const endIndex = startIndex + bankStore.itemsPerPageTransactions;
  return bankStore.driverTransactions.slice(startIndex, endIndex);
});

// 改變頁數
const changeTransactionPage = (page) => {
  if (page >= 1 && page <= bankStore.totalTransactionPages) {
    bankStore.currentPageTransactions = page;
    updateSelectedSummary();
  }
};

// 全選/取消全選交易
const toggleSelectAllTransactions = () => {
  if (!isSelectAllTransactions.value) {
    // 全選所有交易而不僅限於當前頁
    bankStore.selectedTransactionIds = bankStore.driverTransactions.map(transaction => transaction.id);
    updateSelectedSummary();
  } else {
    bankStore.selectedTransactionIds = [];
    updateSelectedSummary();
  }
  isSelectAllTransactions.value = !isSelectAllTransactions.value;
};

// 全選/取消全選司機
const toggleSelectAllDrivers = () => {
  if (isSelectAllDrivers.value) {
    bankStore.selectedDriverIds = [];
    updateSelectedSummary();
  } else {
    bankStore.selectedDriverIds = filteredDriverIds.value.map(driver => driver.driver_id);
    updateSelectedSummary();
  }
  isSelectAllDrivers.value = !isSelectAllDrivers.value;
};


// 監聽單選交易變化
const handleTransactionSelectChange = () => {
  if (bankStore.selectedTransactionIds.length === bankStore.driverTransactions.length) {
    isSelectAllTransactions.value = true;
    updateSelectedSummary();
  } else {
    isSelectAllTransactions.value = false;
    updateSelectedSummary();
  }
};


const handleDriverSelectChange = () => {
  if (bankStore.selectedDriverIds.length === filteredDriverIds.value.length) {
    isSelectAllDrivers.value = true;
    updateSelectedSummary();
  } else {
    isSelectAllDrivers.value = false;
    updateSelectedSummary();
  }
};



// 查詢交易信息並顯示在表格中
const searchDrivers = async () => {
  if (bankStore.selectedDriverIds.length === 0) {
    Swal.fire({
    icon: 'warning',
    title: 'Please select at least one driver',
    text: 'You must select at least one option to retrieve transaction data.',
    confirmButtonText: 'OK'
  });
    return;
  }

  await bankStore.fetchDriverTransactions(); // 呼叫 API 取得交易資料
  updateSelectedSummary(); // 更新交易統計數據
};

// 更新交易統計數據
const updateSelectedSummary = () => {
  if (!Array.isArray(bankStore.driverTransactions)) return;

  const selectedTransactions = bankStore.driverTransactions.filter((t) =>
    bankStore.selectedTransactionIds.includes(t.id)
  );

  selectedSummary.value = {
    transactionCount: selectedTransactions.length,
    totalSFV: selectedTransactions.reduce((acc, t) => acc + parseFloat(t.face_value), 0),
    totalCommissionAmount: selectedTransactions.reduce(
      (acc, t) => acc + parseFloat(t.comm_amount),
      0
    ),
    totalFeesAndRefunds: bankStore.fees_and_refunds || 0,
    totalAmount: selectedTransactions.reduce(
      (acc, t) => acc + parseFloat(t.face_value) + parseFloat(t.comm_amount),
      0
    ),
  };
};

// 監聽日期範圍變動並更新交易數據
watch([fromDate, toDate], async () => {
  // 如果沒有選擇任何司機，則不執行更新交易的邏輯
  if (bankStore.selectedDriverIds.length === 0) {
    // 格式化日期為 'YYYY-MM-DD'
    const formattedFromDate = dayjs(fromDate.value).format('YYYY-MM-DD');
    const formattedToDate = dayjs(toDate.value).format('YYYY-MM-DD');
    
    // 更新 Pinia store 中的日期範圍
    bankStore.fromDate = formattedFromDate;
    bankStore.toDate = formattedToDate;
    return; // 中止後續操作
  }

  // 格式化日期為 'YYYY-MM-DD'
  const formattedFromDate = dayjs(fromDate.value).format('YYYY-MM-DD');
  const formattedToDate = dayjs(toDate.value).format('YYYY-MM-DD');
  
  // 更新 Pinia store 中的日期範圍
  bankStore.fromDate = formattedFromDate;
  bankStore.toDate = formattedToDate;

  // 呼叫 API 查詢資料
  await bankStore.fetchDriverTransactions();
  bankStore.currentPageTransactions = 1;
  updateSelectedSummary();
});



// 保存並關閉
const handleSaveClose = async () => {
  if (bankStore.selectedTransactionIds.length === 0 || bankStore.selectedDriverIds.length === 0) {
    Swal.fire({
      icon: 'warning',
      title: 'Please select transactions and drivers',
      text: 'You must select at least one transaction and one driver to proceed.',
      confirmButtonText: 'OK'
    });
    return;
  }

  const res = await bankStore.createBankTransfer(); // 呼叫 createBankTransfer API
  if (res) {
    cashPaymentStore.changePage(1);
    hideModal(); // 隱藏模態框
  }
};

// 在組件掛載時調用 API 並初始化司機ID列表
onMounted(() => {
  bankStore.fetchDriverIds().then(() => {
    filteredDriverIds.value = [...bankStore.driverIds]; // 載入所有ID並進行初始設置
  });
});

// 新增每頁顯示筆數下拉選項
const handlePageSizeChange = () => {
  // 當每頁顯示筆數改變時，重置到第一頁
  bankStore.currentPageTransactions = 1;
  updateSelectedSummary();
};
</script>


<style scoped>
.btn-query {
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  text-align: center;
  gap: 10px;
  width: 89px;
  height: 34.2px;
  background: #04FF7F;
  border-radius: 27.8571px;
  flex: none;
  order: 2;
  flex-grow: 0;
}

.btn-green:hover {
  background: #00b452;
}

.modal-size {
  max-width: 80%;
}
.bg-lightgreen {
  background-color: #b8e3d0;
  padding: 10px;
  border-radius: 5px;
}

.table-responsive {
  max-height: 300px;
  overflow-y: auto;
  padding-top: 0px;
}

.driver-license-image {
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
}

.no-results {
  border-radius: 20px;
  padding: 50px;
  font-size: 20px;
  text-align: center;
  color: black;
  background-color: #ccd3da;
}

.d-flex {
  display: flex;
  align-items: flex-start;
}

.fixed-modal {
  overflow: hidden;
}

.form-group {
  margin-top: 10px;
}


.license-card {
  border-radius: 5px;
  padding: 5px;
  padding-top: 10px;
  background-color: white;
}

.thead-light th {
  background-color: #f8f9fa;
  color: #495057;
}

.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  justify-content: space-between;
}

.table-responsive .table tbody tr td:nth-child(n+2) {
  min-width: 150px !important;
}

.card {
  background-color: #e6e9ec;
}

.card-body {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
}

/* 設置 search-list 容器的樣式 */
.search-list {
  max-height: 250px; /* 限制容器的最大高度 */
  overflow-y: auto; /* 當內容超出時顯示滾動條 */
  padding: 10px; /* 設置內間距 */
  border-radius: 5px; /* 設置圓角 */
  border: 1px solid #d1d9e6; /* 邊框顏色 */
  display: flex;
  flex-direction: column; /* 垂直排列子元素 */
  gap: 8px; /* 子元素之間的間距 */
  width: 100%; /* 確保容器寬度填滿父容器 */
  box-sizing: border-box; /* 包括邊框和內距在內的寬度計算 */
}

/* 調整 custom-driver-check 內部的佈局和樣式 */
.custom-driver-check {
  display: flex;
  align-items: center; /* 垂直居中 */
  width: 100%; /* 確保每行寬度填滿 */
}

.custom-driver-check input[type="checkbox"] {
  margin-right: 10px; /* 複選框和文字之間的距離 */
  width: 20px; /* 調整複選框的大小 */
  height: 20px; /* 調整複選框的大小 */
  accent-color: #04FF7F; /* 複選框的顏色 */
}

.custom-driver-check label {
  font-size: 16px; /* 調整文字大小 */
  color: #333; /* 文字顏色 */
  flex-grow: 1; /* 讓 label 自適應寬度，填滿剩餘空間 */
  word-wrap: break-word; /* 如果文字太長，自動換行 */
}

/* 滾動條樣式 */
.search-list::-webkit-scrollbar {
  width: 8px; /* 滾動條的寬度 */
}

.search-list::-webkit-scrollbar-thumb {
  background-color: #a1a1a1; /* 滾動條的顏色 */
  border-radius: 10px; /* 滾動條的圓角 */
}

.search-list::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* 滾動條背景 */
}

/* Checkbox 成功樣式 (和你的 'checkbox-success' 保持一致) */
.checkbox-success .form-check-input:checked {
  background-color: #28a745; /* 已選中時的背景色 */
  border-color: #28a745; /* 已選中時的邊框色 */
}

.checkbox-success .form-check-input {
  background-color: #fff;
  border-color: #dcdcdc; /* 未選中時的邊框色 */
}

.checkbox-success .form-check-label {
  color: #333; /* 文字顏色 */
}


@media (max-width: 768px) {
  .modal-size {
    max-width: 100%;
  }
  .table-responsive {
    max-height: 250px;
  }
  .table {
    font-size: 12px;
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}

.pagination-container {
  display: flex;
  align-items: center;
}

.pagination-container button {
  border: none;
  background: none;
  cursor: pointer;
  font-size: 16px;
  color: #8476f4;
}

.pagination-container span {
  margin: 0 10px;
}

.pagination-container input {
  width: 50px;
  text-align: center;
}

.total-count {
  font-size: 16px;
  color: #666;
}

@media (max-width: 630px) {
  .pagination-wrapper {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .pagination-summary {
    margin-top: 10px;
    justify-content: center;
  }
  .pagination-container {
    justify-content: center;
    width: 100%;
    margin-bottom: 10px;
  }
}

@media (max-width: 768px) {
  .filter-toggle-icon {
    justify-content: center;
    font-size: 20px;
  }
  .btn-reset, .btn-green, .btn-toggle {
    width: 100%;
    margin-top: 10px;
  }
  .btn-reset {
    margin-right: 0;
  }
  .text-end {
    text-align: center !important;
  }
}
</style>
